<template>
    <div class="col profile-box">
        <div class="profile-pic" >
            <img  class="profile-img" :src="profile_data.image!='no-image' ? profile_data.image :'https://ui-avatars.com/api/?name='+current_user_name" >
            <img  class="image-edit" src="../assets/camera.png" @click="toggleShow">
        </div>
        <!-- <div class="profile-pic" v-else>
            <img :src="item.src" />
           
        </div> -->
        <div>
           <!-- <a class="btn" >set avatar</a> -->
            <my-upload
                field="img"
                @crop-success="cropSuccess"
                @crop-upload-success="cropUploadSuccess"
                v-model="show1"
                :width="300"
                :height="300"
                :background="true"
                :url="api"
                :params="params"
                :headers="headers"
                noSquare=""
                lang-type="en"
                img-format="png"
            >
            </my-upload>
        </div>
     <!--  {{item.image }} -->
        <b-form @submit="onSubmit" @reset="onReset" v-if="show" class="text-left">
          <!--   <b-row>
                <b-form-group  label-for="form-image" class="col">
                    <b-input-group>
                        <b-form-file id="form-image" @change="onFileChange(item, $event)" accept="image/*"></b-form-file>
                    </b-input-group>   
                </b-form-group>
            </b-row> -->
            <b-row>
                <b-form-group 
                id="fname-group"
                label-for="fname"
                class="col-sm-6"
                >
                    <b-form-input
                      id="fname"
                      v-model="profile_data.first_name"
                      type="text"
                      required
                      placeholder="First Name"
                    ></b-form-input>
                </b-form-group>
                <b-form-group id="lname-group" label-for="lname" class="col-sm-6">
                    <b-form-input
                      id="lname"
                      v-model="profile_data.last_name"
                      required
                      placeholder="Last Name"
                    ></b-form-input>
                </b-form-group>
            </b-row>
            <b-row>
                <b-form-group id="email-group" label-for="email" class="col-sm-6">
                    <b-form-input
                      id="email"
                      v-model="profile_data.email"
                      type="email"
                      required
                      placeholder="Email ID"
                    ></b-form-input>
                </b-form-group>
                <b-form-group id="phone-group" label-for="phone" class="col-sm-6">
                    <b-form-input
                      id="phone"
                      v-model="profile_data.mobile_no"
                      required
                      placeholder="Phone Number"
                    ></b-form-input>
                </b-form-group>
            </b-row>
            <b-row>
                <b-form-group id="password-group" label-for="password" class="col-sm-6">
                    <b-form-input
                      id="password"
                      v-model="form.password"
                      type="password"
                      required
                      placeholder="Password"
                    ></b-form-input>
                </b-form-group>
                <b-form-group id="repassword-group" label-for="repassword" class="col-sm-6">
                    <b-form-input
                      id="repassword"
                      v-model="form.repassword"
                      type="password"
                      required
                      placeholder="Repeat Password"
                    ></b-form-input>
                </b-form-group>
            </b-row>
            <b-button type="submit" variant="primary" class="btn btn-primary">Update</b-button>
            <b-button type="reset"  class="btn btn-primary-inverse">Reset</b-button>
        </b-form>
       <!--  <b-card class="mt-3" header="Form Data Result">
          <pre class="m-0">{{ form }}</pre>
        </b-card> -->
    </div>
</template>
<script>
import Ls from '../services/ls'
import { mapGetters } from 'vuex'
import myUpload from 'vue-image-crop-upload';
export default {
    name: 'personal_information',
    components: {
            'my-upload': myUpload
        },
    data() {
        return {
          current_user_name:Ls.get('_u_name'),
          api:process.env.VUE_APP_API+'/profile/image/upload',
            form: {
                fname: '',
                lname: '',
                address:'',
                email:'',
                phone:'',
                password:'',
                repassword:'',
            },
            item:{
                image: false,
                src:''
            },
            show: true,
            dpupload :false,
            show1: false,
            params: {
                token: '123456798',
                name: 'avatar'
            },
            headers: {
               Authorization: "Bearer " + Ls.get("token"),
              "X-Requested-With": "XMLHttpRequest",
            },
            imgDataUrl: '/img/user-icon.9b3ef6c9.png', // the datebase64 url of created image
            field:''
        }
    },
    props: [],
    watch: {
        
    },
    computed:{
		...mapGetters('profile', {
			profile_data: 'profile_data',
		})
	},
    methods: {
        onSubmit(evt) {
            evt.preventDefault()
            // alert(JSON.stringify(this.profile_data))
            this.$store.dispatch('profile/update',this.profile_data)
               .then(() => {
                  this.$emit("NameUpdate", {
                  name:this.profile_data.first_name+' '+this.profile_data.last_name
                })
                  this.$notify({
                    group: 'auth',
                    title:'Success',
                    type: 'success',
                    text: 'Profile updated successfully'
                  });
               })
        },
        onReset(evt) {
            evt.preventDefault()
            // Reset our form values    
            this.form.lname = ''
            this.form.fname = ''
            this.form.email = ''
            this.form.phone = ''
            this.form.address = ''
            this.form.password = ''
            this.form.repassword = ''
            this.show = false
            this.$nextTick(() => {
              this.show = true
            })
        },
        onFileChange(item, e) {
          var files = e.target.files || e.dataTransfer.files;
          if (!files.length)
            return;
          this.createImage(item, files[0]);
          this.dpupload=true;
        },
        createImage(item, file) {
          item.image = new Image();
          var reader = new FileReader();
          reader.onload = (e) => {
            this.item.src = e.target.result;
            this.item.image = true;
            // console.log(e.target.result);
          };
          reader.readAsDataURL(file);
        },
        removeImage: function (item) {
          item.image = false; 
        },
        toggleShow() {
          this.show1 = !this.show1;
        },
        cropSuccess(imgDataUrl) {
            this.imgDataUrl = imgDataUrl;
        },
        cropUploadSuccess() {
          this.show1 = false;
          // this.item.image=true;
          window.location.reload();
          this.$store.dispatch('profile/fetchProfile');
        },
         
    },
    created(){
       
    },
    mounted(){
      this.$store.dispatch('profile/fetchProfile')
    }
};
</script>
